export const TileType = {
  GRASS : '1.png',
  FIRE : '2.png',
  WATER : '3.png',
  STUMP : '4.png',
  WOOL : '5.png',
  BELL : '6.png',
  CARROT : '7.png',
  SHEEP : '8.png',
  CORN : '9.png'
}

export const GameStatus = {
  idle : 'idle',
  playing : 'playing',
  won : 'won',
  lost : 'lost'
};

export const GameConfig = {
  maxSlots : 3,
  maxRevives : 3
}